import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css'; 
import 'slick-carousel/slick/slick-theme.css';

const Carousel = ({ carouselImages }) => {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  return (
    <div className="w-full p-[2px] bg-white rounded-lg shadow-md hidden lg:block">
      <Slider {...settings}>
        {carouselImages.map((src, index) => (
          <div key={index} className="w-full lg:h-[35vh] xl:h-[55vh] slider-bg"> 
            <img
              src={src}
              alt={`Slide ${index + 1}`}
              className="w-full h-full object-cover rounded-md" 
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Carousel;
